import { useApi }                           from '../utils/api'
import {
  useCallback, useContext,
  useEffect, useState }                     from 'react'
import { AppContext }                       from '../App'
import { User }                             from '../consts'

let providers
export default function useProviders () {
  const api = useApi()
  const [local, setLocal] = useState(providers)
  const [reload, setReload] = useState(0)
  const { user } = useContext(AppContext)

  const reloadFnc = useCallback(() => {
    providers = undefined
    setReload(reload => reload + 1)
  }, [])

  useEffect(() => {
    if (user?.type !== User.typeAdmin) {
      setLocal([])
      return
    }
      async function load () {
      providers = (await api.provider.list()).data
      setLocal(providers)
    }

    if (providers === undefined) {
      load()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reload, user])

  return [local, reloadFnc]
}